<template>
  <div class="zhanwei4"></div>
  <div class="role-module-wrapper">
    <div class="section-intro-bar">
      <div class="intro-left">
        <div class="icon-avatar">
          <el-icon><UserFilled /></el-icon>
        </div>
        <div class="intro-text">
          <h3 class="title">剧本角色阵容配置</h3>
          <p class="desc">
            配置可供玩家在冒险中选择或交互的人物档案、特有技能与专属属性
          </p>
        </div>
      </div>
      <div class="intro-badge">
        <span>当前共 {{ roles.length }} 位角色</span>
      </div>
    </div>

    <div class="role-container">
      <div class="role-list">
        <div
          class="role-card"
          v-for="(item, index) in roles"
          :key="item.roleId || index"
        >
          <div class="card-glass-bg"></div>

          <div class="role-card-banner">
            <div class="role-avatar-wrapper">
              <el-image :src="item.roleImg" fit="contain" class="role-image">
                <template #error>
                  <div class="image-fallback">
                    <el-icon><Avatar /></el-icon>
                  </div>
                </template>
              </el-image>
            </div>

            <div class="key-role-badge" v-if="Number(item.isKeyRole) === 1">
              <el-icon><StarFilled /></el-icon>
              <span>关键角色</span>
            </div>

            <div class="role-badge-tag">
              {{ item.roleProfession || "旅行者" }}
            </div>
          </div>

          <div class="role-card-info">
            <h4 class="role-name">{{ item.roleName || "未命名角色" }}</h4>
            <div class="role-meta-chips">
              <span class="chip" v-if="item.roleSex">
                <el-icon
                  ><Female v-if="item.roleSex === '女'" /><Male v-else
                /></el-icon>
                {{ item.roleSex }}
              </span>
              <span class="chip" v-if="item.roleAge"
                >{{ item.roleAge }} 岁</span
              >
            </div>
            <p class="role-desc-preview">
              {{ item.roleDesc || "暂无角色生平背景描述..." }}
            </p>
          </div>

          <div class="role-card-footer">
            <el-button
              type="primary"
              class="edit-btn"
              @click="
                editRole(index);
                isUpdate = true;
              "
            >
              <el-icon><EditPen /></el-icon>
              编辑
            </el-button>
            <el-popconfirm
              title="确认解雇/移除该角色吗?"
              @confirm="deleteRole(index)"
            >
              <template #reference>
                <el-button class="del-btn" circle>
                  <el-icon><Delete /></el-icon>
                </el-button>
              </template>
            </el-popconfirm>
          </div>
        </div>

        <div class="role-card add-role-trigger" @click="openAddDialog">
          <div class="add-pulsing-box">
            <div class="plus-circle">
              <el-icon><Plus /></el-icon>
            </div>
            <p class="add-title">加入全新角色</p>
            <span class="add-subtitle">点击配置立绘与专属数值</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <el-dialog
    v-model="customDraggingVisible"
    class="custom-dragging-style"
    :title="isUpdate ? '编辑角色档案' : '录入全新角色'"
    width="960px"
    draggable
    destroy-on-close
    :close-on-click-modal="false"
  >
    <div class="role_add">
      <div class="role_add_left">
        <div class="upload-section-card">
          <div class="sec-header">
            <span class="sec-title">角色立绘形象</span>
            <span class="sec-sub"
              >建议尺寸 1080×1920px (支持 JPG/PNG/WEBP，≤5MB)</span
            >
          </div>
          <div class="uploader-wrapper">
            <el-upload
              v-model:file-list="fileList"
              :action="UpdateApi"
              list-type="picture-card"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
              :before-remove="handleBeforeRemove"
              :limit="1"
              class="role-uploader-box"
            >
              <div class="upload-inner">
                <el-icon><Plus /></el-icon>
                <span>点击上传立绘</span>
              </div>
            </el-upload>
          </div>
        </div>

        <div class="form-section-card">
          <el-form
            :model="form"
            label-width="auto"
            label-position="top"
            class="clean-form"
          >
            <div class="form-row">
              <el-form-item label="角色姓名" required>
                <el-input
                  v-model="form.name"
                  placeholder="例如：林九霄"
                  maxlength="20"
                  clearable
                />
              </el-form-item>
              <el-form-item label="身份/职业">
                <el-input
                  v-model="form.profession"
                  placeholder="例如：古董鉴定师"
                  maxlength="20"
                  clearable
                />
              </el-form-item>
            </div>

            <div class="form-row">
              <el-form-item label="性别">
                <el-input
                  v-model="form.sex"
                  placeholder="男 / 女 / 未知"
                  maxlength="10"
                />
              </el-form-item>
              <el-form-item label="年龄">
                <el-input
                  v-model="form.age"
                  placeholder="例如：24"
                  maxlength="10"
                />
              </el-form-item>
              <el-form-item label="剧情关键角色" class="key-role-switch-item">
                <div class="switch-control-box">
                  <el-switch
                    v-model="form.isKeyRole"
                    :active-value="1"
                    :inactive-value="0"
                    active-text="是"
                    inactive-text="否"
                    inline-prompt
                  />
                  <span class="switch-tip">核心主线人物</span>
                </div>
              </el-form-item>
            </div>

            <el-form-item label="专属特长或技能">
              <el-input
                v-model="form.skill"
                type="textarea"
                :rows="2"
                placeholder="例如：擅长机关辨识与夜行，可解读上古密文..."
                show-word-limit
                maxlength="200"
              />
            </el-form-item>

            <el-form-item label="人物生平与背景">
              <el-input
                v-model="form.desc"
                type="textarea"
                :rows="3"
                placeholder="简述人物的性格特征、动机暗线与阵营关系..."
                show-word-limit
                maxlength="200"
              />
            </el-form-item>
          </el-form>
        </div>
      </div>

      <div class="role_add_right">
        <div class="preview-header">
          <span class="badge-dot"></span>
          <span>移动端角色名片视口</span>
        </div>

        <div class="mockup-phone">
          <div class="phone-top-bar">
            <div class="notch"></div>
          </div>

          <div class="phone-screen">
            <div class="mock-nav">
              <span class="nav-title">人物档案</span>
            </div>

            <div class="screen-portrait">
              <el-image
                v-if="form.img"
                :src="form.img"
                fit="cover"
                class="portrait-img"
              />
              <div v-else class="media-placeholder">
                <el-icon class="ph-icon"><Avatar /></el-icon>
                <span>暂未上传角色立绘</span>
              </div>

              <div class="mobile-key-badge" v-if="Number(form.isKeyRole) === 1">
                <el-icon><StarFilled /></el-icon>
                <span>核心关键人物</span>
              </div>

              <div class="portrait-gradient-layer"></div>
              <div class="portrait-name-floating">
                <span class="hero-name">{{ form.name || "未定名" }}</span>
                <span class="hero-prof">{{ form.profession || "游荡者" }}</span>
              </div>
            </div>

            <div class="screen-info-board">
              <div class="tags-row">
                <div class="spec-pill">
                  <span class="k">性别</span>
                  <span class="v">{{ form.sex || "-" }}</span>
                </div>
                <div class="spec-pill">
                  <span class="k">年龄</span>
                  <span class="v">{{ form.age || "-" }}</span>
                </div>
              </div>

              <div class="detail-box">
                <span class="box-label">专属能力</span>
                <p class="box-val">{{ form.skill || "暂未领悟技能" }}</p>
              </div>

              <div class="detail-box">
                <span class="box-label">档案背景</span>
                <p class="box-val">
                  {{ form.desc || "暂未录入人物背景档案..." }}
                </p>
              </div>
            </div>

            <div class="screen-footer">
              <button class="mock-select-btn">选用此角色出发</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <template #footer>
      <div class="dialog-footer">
        <el-button @click="customDraggingVisible = false" class="cancel-btn"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click="isUpdate ? updateRole() : addRole()"
          class="confirm-btn"
        >
          {{ isUpdate ? "确定修改档案" : "立即创建角色" }}
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import {
  Plus,
  UserFilled,
  Avatar,
  Female,
  Male,
  EditPen,
  Delete,
  StarFilled,
} from "@element-plus/icons-vue";
import { ElNotification, ElMessage } from "element-plus";

export default defineComponent({
  name: "RoleManagerModule",
  components: {
    Plus,
    UserFilled,
    Avatar,
    Female,
    Male,
    EditPen,
    Delete,
    StarFilled,
  },
  data() {
    return {
      customDraggingVisible: false,
      fileList: [] as any[],
      isUpdate: false,
      form: {
        id: "",
        name: "",
        desc: "",
        img: "",
        sex: "",
        profession: "",
        age: "",
        skill: "",
        isKeyRole: 0,
      },
      roles: [] as any[],
    };
  },
  computed: {
    UpdateApi(): string {
      return process.env.VUE_APP_Update_API || "";
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const gameId = this.$route.params.id;
      if (!gameId) return;
      this.$store
        .dispatch("game/getRoles", { gameId })
        .then((res: any) => {
          this.roles = Array.isArray(res) ? res : [];
          this.customDraggingVisible = false;
          this.resetForm();
        })
        .catch(() => {});
    },

    resetForm() {
      this.form = {
        id: "",
        name: "",
        desc: "",
        img: "",
        sex: "",
        profession: "",
        age: "",
        skill: "",
        isKeyRole: 0,
      };
      this.fileList = [];
    },

    openAddDialog() {
      this.resetForm();
      this.isUpdate = false;
      this.customDraggingVisible = true;
    },

    /**
     * 通用删除远程文件逻辑
     */
    async deleteRemoteFile(fileName: string): Promise<boolean> {
      if (!fileName) return false;
      try {
        const delFinished = await this.$store.dispatch("user/delFile", {
          fileName,
        });
        return delFinished === 1 || delFinished === true;
      } catch (error) {
        console.error("立绘删除失败:", error);
        return false;
      }
    },

    /**
     * 上传前校验，并在替换前先删除原图
     */
    async beforeAvatarUpload(file: File): Promise<boolean> {
      const isAllowed =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/webp" ||
        file.type === "image/gif";
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isAllowed) {
        ElNotification.warning({
          message: "仅支持 JPG/PNG/WEBP/GIF 格式图片",
          offset: 100,
        });
        return false;
      }
      if (!isLt5M) {
        ElNotification.warning({
          message: "图片大小不可超过 5MB",
          offset: 100,
        });
        return false;
      }

      // 如果已有旧立绘，上传替换前先将远程服务器上的旧文件清理
      if (this.form.img) {
        await this.deleteRemoteFile(this.form.img);
      }

      return true;
    },

    /**
     * 点击上传列表自带的“垃圾桶/移除”按钮时触发
     */
    async handleBeforeRemove(): Promise<boolean> {
      if (this.form.img) {
        const success = await this.deleteRemoteFile(this.form.img);
        if (success) {
          this.form.img = "";
          ElMessage.success("已移除并删除立绘");
          return true;
        } else {
          ElMessage.error("远程立绘删除失败");
          return false;
        }
      }
      return true;
    },

    handleAvatarSuccess(response: any) {
      if (response?.data?.returnFileUrl) {
        this.form.img = response.data.returnFileUrl;
      }
    },

    addRole() {
      this.$store
        .dispatch("game/saveRole", {
          gameId: this.$route.params.id,
          roleDesc: this.form.desc,
          roleImg: this.form.img,
          roleName: this.form.name,
          roleAge: this.form.age,
          roleSex: this.form.sex,
          roleProfession: this.form.profession,
          roleSkill: this.form.skill,
          isKeyRole: Number(this.form.isKeyRole) || 0,
        })
        .then(() => {
          this.init();
        })
        .catch(() => {});
    },

    editRole(index: number) {
      const target = this.roles[index];
      if (!target) return;
      this.form.desc = target.roleDesc || "";
      this.form.name = target.roleName || "";
      this.form.img = target.roleImg || "";
      this.form.id = target.roleId || "";
      this.form.age = target.roleAge || "";
      this.form.sex = target.roleSex || "";
      this.form.profession = target.roleProfession || "";
      this.form.skill = target.roleSkill || "";
      this.form.isKeyRole = Number(target.isKeyRole) || 0;

      this.fileList = [];
      if (target.roleImg) {
        this.fileList.push({
          name: (target.roleName || "role") + ".jpg",
          url: target.roleImg,
        });
      }
      this.customDraggingVisible = true;
    },

    /**
     * 删除整个角色时，同时联动删除角色已上传的立绘
     */
    async deleteRole(index: number) {
      const target = this.roles[index];
      if (!target) return;

      try {
        if (target.roleImg) {
          await this.deleteRemoteFile(target.roleImg);
        }

        await this.$store.dispatch("game/delRole", {
          ids: [target.roleId],
        });
        this.init();
      } catch (error) {
        console.error("删除角色失败:", error);
      }
    },

    updateRole() {
      this.$store
        .dispatch("game/updRole", {
          roleId: this.form.id,
          gameId: this.$route.params.id,
          roleDesc: this.form.desc,
          roleImg: this.form.img,
          roleName: this.form.name,
          roleAge: this.form.age,
          roleSex: this.form.sex,
          roleProfession: this.form.profession,
          roleSkill: this.form.skill,
          isKeyRole: Number(this.form.isKeyRole) || 0,
        })
        .then(() => {
          this.init();
        })
        .catch(() => {});
    },
  },
});
</script>

<style scoped lang="less">
@primary-color: #5d5fef;
@primary-light: #f0f2ff;
@text-main: #1e293b;
@text-sub: #64748b;
@text-muted: #94a3b8;
@border-color: #e2e8f0;
@card-border: #f1f5f9;
@danger-color: #ef4444;
@gold-color: #f59e0b;

.zhanwei4 {
  height: 20px;
}

.role-module-wrapper {
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;
}

// 顶部说明卡片
.section-intro-bar {
  background: #ffffff;
  border: 1px solid @card-border;
  border-radius: 14px;
  padding: 16px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 4px 18px rgba(15, 23, 42, 0.03);
  margin-bottom: 24px;

  .intro-left {
    display: flex;
    align-items: center;
    gap: 14px;

    .icon-avatar {
      width: 42px;
      height: 42px;
      border-radius: 10px;
      background: @primary-light;
      color: @primary-color;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 22px;
    }

    .intro-text {
      .title {
        margin: 0 0 3px 0;
        font-size: 16px;
        font-weight: 700;
        color: @text-main;
      }
      .desc {
        margin: 0;
        font-size: 12.5px;
        color: @text-muted;
      }
    }
  }

  .intro-badge {
    span {
      font-size: 12px;
      font-weight: 600;
      color: @primary-color;
      background: @primary-light;
      padding: 4px 12px;
      border-radius: 20px;
    }
  }
}

// 横向滑动画廊
.role-container {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 16px;

  &::-webkit-scrollbar {
    height: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #cbd5e1;
    border-radius: 3px;
  }

  .role-list {
    display: flex;
    flex-wrap: nowrap;
    gap: 24px;
    padding: 6px 4px 16px;
  }
}

// 现代化人物立绘名片
.role-card {
  flex: 0 0 260px;
  width: 260px;
  height: 420px;
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid @border-color;
  box-shadow: 0 6px 18px -4px rgba(15, 23, 42, 0.05);
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 16px 28px -6px rgba(93, 95, 239, 0.18);
    border-color: #c7d2fe;
  }

  .role-card-banner {
    position: relative;
    height: 200px;
    width: 100%;
    background: #f8fafc;
    overflow: hidden;

    .role-avatar-wrapper {
      width: 100%;
      height: 100%;

      .role-image {
        width: 100%;
        height: 100%;
        transition: transform 0.4s ease;
      }

      .image-fallback {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #f1f5f9;
        color: @text-muted;
        font-size: 40px;
      }
    }

    // 关键角色徽章
    .key-role-badge {
      position: absolute;
      top: 12px;
      left: 12px;
      background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
      color: #ffffff;
      font-size: 11px;
      font-weight: 700;
      padding: 3px 8px;
      border-radius: 6px;
      display: flex;
      align-items: center;
      gap: 3px;
      box-shadow: 0 2px 8px rgba(217, 119, 6, 0.35);
      z-index: 2;

      .el-icon {
        font-size: 12px;
      }
    }

    .role-badge-tag {
      position: absolute;
      top: 12px;
      right: 12px;
      background: rgba(15, 23, 42, 0.65);
      backdrop-filter: blur(4px);
      color: #ffffff;
      font-size: 11px;
      font-weight: 600;
      padding: 3px 8px;
      border-radius: 6px;
      letter-spacing: 0.5px;
    }
  }

  &:hover .role-image {
    transform: scale(1.08);
  }

  .role-card-info {
    flex: 1;
    padding: 14px 16px;
    display: flex;
    flex-direction: column;

    .role-name {
      margin: 0 0 8px 0;
      font-size: 16px;
      font-weight: 700;
      color: @text-main;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .role-meta-chips {
      display: flex;
      gap: 6px;
      margin-bottom: 8px;

      .chip {
        display: inline-flex;
        align-items: center;
        gap: 3px;
        font-size: 11px;
        color: @text-sub;
        background: #f1f5f9;
        padding: 2px 7px;
        border-radius: 4px;
        font-weight: 500;
      }
    }

    .role-desc-preview {
      margin: 0;
      font-size: 12px;
      color: @text-muted;
      line-height: 1.5;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }

  .role-card-footer {
    padding: 10px 16px 14px;
    display: flex;
    align-items: center;
    gap: 10px;
    border-top: 1px solid #f8fafc;

    .edit-btn {
      flex: 1;
      height: 36px;
      border-radius: 8px;
      font-size: 13px;
      font-weight: 600;
      background: @primary-light;
      border-color: #dce2ff;
      color: @primary-color;
      transition: all 0.2s;

      &:hover {
        background: @primary-color;
        border-color: @primary-color;
        color: #ffffff;
      }
    }

    .del-btn {
      width: 36px;
      height: 36px;
      border-color: transparent;
      color: @text-muted;

      &:hover {
        background: #fee2e2;
        color: @danger-color;
      }
    }
  }
}

// “创建角色”按钮卡片
.add-role-trigger {
  border: 2px dashed #cbd5e1;
  background: linear-gradient(
    180deg,
    rgba(248, 250, 252, 0.8) 0%,
    rgba(241, 245, 249, 0.4) 100%
  );
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    border-color: @primary-color;
    background: @primary-light;
    transform: translateY(-8px);
    box-shadow: 0 14px 28px -6px rgba(93, 95, 239, 0.15);

    .plus-circle {
      background: @primary-color;
      color: #ffffff;
      transform: scale(1.1) rotate(90deg);
    }

    .add-title {
      color: @primary-color;
    }
  }

  .add-pulsing-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 0 20px;

    .plus-circle {
      width: 52px;
      height: 52px;
      border-radius: 50%;
      background: #ffffff;
      color: @primary-color;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 22px;
      box-shadow: 0 4px 12px rgba(15, 23, 42, 0.08);
      margin-bottom: 14px;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }

    .add-title {
      margin: 0 0 4px 0;
      font-size: 15px;
      font-weight: 700;
      color: @text-main;
      transition: color 0.2s;
    }

    .add-subtitle {
      font-size: 11.5px;
      color: @text-muted;
    }
  }
}

// 弹窗布局
.role_add {
  display: flex;
  gap: 36px;
  align-items: flex-start;

  &_left {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 20px;

    .upload-section-card {
      background: #f8fafc;
      border: 1px solid @border-color;
      border-radius: 12px;
      padding: 16px 20px;

      .sec-header {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        margin-bottom: 12px;

        .sec-title {
          font-size: 14px;
          font-weight: 700;
          color: @text-main;
        }
        .sec-sub {
          font-size: 11.5px;
          color: @text-muted;
        }
      }

      :deep(.role-uploader-box) {
        .el-upload--picture-card {
          width: 110px;
          height: 110px;
          border-radius: 10px;
          border: 1.5px dashed #cbd5e1;
          background: #ffffff;

          &:hover {
            border-color: @primary-color;
            background: @primary-light;
          }
        }

        .upload-inner {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 6px;
          font-size: 11px;
          color: @text-muted;

          .el-icon {
            font-size: 20px;
            color: @text-sub;
          }
        }
      }
    }

    .form-section-card {
      .clean-form {
        .form-row {
          display: flex;
          gap: 16px;
          align-items: flex-start;

          .el-form-item {
            flex: 1;
          }
        }

        .key-role-switch-item {
          flex: 0 0 140px !important;

          .switch-control-box {
            display: flex;
            align-items: center;
            gap: 10px;
            height: 32px;

            .switch-tip {
              font-size: 12px;
              color: @text-muted;
            }
          }
        }

        :deep(.el-form-item) {
          margin-bottom: 18px;

          .el-form-item__label {
            font-size: 13px;
            font-weight: 600;
            color: @text-main;
            padding-bottom: 4px;
          }
        }

        :deep(.el-input__wrapper),
        :deep(.el-textarea__inner) {
          border-radius: 8px;
          box-shadow: 0 0 0 1px @border-color inset;

          &:hover {
            box-shadow: 0 0 0 1px #cbd5e1 inset;
          }
          &.is-focus,
          &:focus {
            box-shadow: 0 0 0 1px @primary-color inset !important;
          }
        }
      }
    }
  }

  // 右侧拟物化真机视口
  &_right {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-shrink: 0;

    .preview-header {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 13px;
      font-weight: 600;
      color: @text-sub;
      margin-bottom: 14px;

      .badge-dot {
        width: 8px;
        height: 8px;
        background: #10b981;
        border-radius: 50%;
        box-shadow: 0 0 6px rgba(16, 185, 129, 0.6);
      }
    }

    .mockup-phone {
      width: 290px;
      height: 550px;
      background: #ffffff;
      border-radius: 36px;
      border: 10px solid #0f172a;
      box-shadow: 0 16px 36px -6px rgba(15, 23, 42, 0.16);
      position: relative;
      overflow: hidden;
      display: flex;
      flex-direction: column;

      .phone-top-bar {
        width: 100%;
        height: 20px;
        display: flex;
        justify-content: center;
        background: #ffffff;
        z-index: 10;

        .notch {
          width: 76px;
          height: 12px;
          background: #0f172a;
          border-bottom-left-radius: 6px;
          border-bottom-right-radius: 6px;
        }
      }

      .phone-screen {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        background: #f8fafc;
      }

      .mock-nav {
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #ffffff;
        border-bottom: 1px solid @border-color;
        font-size: 13px;
        font-weight: 700;
        color: @text-main;
      }

      .screen-portrait {
        width: 100%;
        height: 210px;
        position: relative;
        background: #e2e8f0;
        overflow: hidden;

        .portrait-img {
          width: 100%;
          height: 100%;
        }

        .media-placeholder {
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 6px;
          color: @text-muted;
          font-size: 11px;

          .ph-icon {
            font-size: 32px;
          }
        }

        // 视口内的关键角色标识
        .mobile-key-badge {
          position: absolute;
          top: 10px;
          left: 10px;
          background: rgba(217, 119, 6, 0.85);
          backdrop-filter: blur(4px);
          color: #ffffff;
          font-size: 10px;
          font-weight: 700;
          padding: 2px 7px;
          border-radius: 4px;
          display: flex;
          align-items: center;
          gap: 3px;
          z-index: 2;
        }

        .portrait-gradient-layer {
          position: absolute;
          inset: 0;
          background: linear-gradient(
            180deg,
            transparent 50%,
            rgba(15, 23, 42, 0.85) 100%
          );
        }

        .portrait-name-floating {
          position: absolute;
          left: 14px;
          bottom: 10px;
          display: flex;
          flex-direction: column;

          .hero-name {
            font-size: 16px;
            font-weight: 800;
            color: #ffffff;
          }
          .hero-prof {
            font-size: 11px;
            color: #cbd5e1;
          }
        }
      }

      .screen-info-board {
        flex: 1;
        padding: 12px 14px;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        gap: 8px;

        .tags-row {
          display: flex;
          gap: 8px;

          .spec-pill {
            flex: 1;
            background: #ffffff;
            border: 1px solid @border-color;
            border-radius: 6px;
            padding: 4px 8px;
            display: flex;
            justify-content: space-between;
            font-size: 11px;

            .k {
              color: @text-muted;
            }
            .v {
              font-weight: 600;
              color: @text-main;
            }
          }
        }

        .detail-box {
          background: #ffffff;
          border: 1px solid @border-color;
          border-radius: 8px;
          padding: 8px 10px;

          .box-label {
            font-size: 10.5px;
            font-weight: 700;
            color: @primary-color;
            display: block;
            margin-bottom: 2px;
          }

          .box-val {
            margin: 0;
            font-size: 11.5px;
            color: @text-sub;
            line-height: 1.45;
          }
        }
      }

      .screen-footer {
        padding: 10px 14px 12px;
        background: #ffffff;
        border-top: 1px solid @border-color;

        .mock-select-btn {
          width: 100%;
          height: 36px;
          border-radius: 18px;
          border: none;
          background: @primary-color;
          color: #ffffff;
          font-size: 12.5px;
          font-weight: 600;
          cursor: default;
          box-shadow: 0 3px 8px rgba(93, 95, 239, 0.3);
        }
      }
    }
  }
}

// 对话框全局美化
:deep(.custom-dragging-style) {
  border-radius: 16px;
  overflow: hidden;

  .el-dialog__header {
    margin: 0;
    padding: 18px 24px;
    border-bottom: 1px solid @border-color;

    .el-dialog__title {
      font-size: 16px;
      font-weight: 700;
      color: @text-main;
    }
  }

  .el-dialog__body {
    padding: 24px;
  }

  .el-dialog__footer {
    padding: 14px 24px 18px;
    border-top: 1px solid @border-color;

    .dialog-footer {
      display: flex;
      justify-content: flex-end;
      gap: 12px;

      .cancel-btn {
        border-radius: 8px;
      }
      .confirm-btn {
        border-radius: 8px;
        background: @primary-color;
        border-color: @primary-color;
        font-weight: 600;
      }
    }
  }
}
</style>
